import React from 'react';
import { Avatar as TPAAvatar, AvatarSize } from 'wix-ui-tpa';
import { Avatar as WSRAvatar } from '@wix/design-system';
function Avatar(props) {
    const { icon, name, isDashboard, imgProps } = props;
    const size = isDashboard ? 'size36' : AvatarSize.medium;
    const AvatarComponent = isDashboard ? WSRAvatar : TPAAvatar;
    if (typeof icon === 'string' || icon === undefined) {
        return React.createElement(AvatarComponent, { size: size, src: icon, name: name, imgProps: imgProps });
    }
    return React.createElement(React.Fragment, null, icon);
}
export default Avatar;
//# sourceMappingURL=Avatar.js.map